import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

import Mapsready from './telas/heatmap/maps';

ReactDOM.render(
  <React.StrictMode>
    <Mapsready />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
